import { AssetTypeSummary } from '@archimed/models';
import { TypeNode } from '../models/type-node.model';
import { RelationshipTreeBuilderService } from './relationship-tree-builder.service';

export class TypeHierarchyBuilderService {
  private readonly relationshipTreeBuilder =
    new RelationshipTreeBuilderService();

  buildFromEntityTypes(entityTypes: AssetTypeSummary[]): TypeNode[] {
    return this.relationshipTreeBuilder.buildTree(entityTypes);
  }
}
